export function getHexcodeByColor (color: string): string {
    switch (color) {
        case 'Silber':
        case 'Mystic Silver':
            return '#CCC';

        case 'Spacegrau':
            return '#333';

        case 'Schwarz':
        case 'Just Black':
        case 'Titanium Grey':
        case 'Black':
        case 'Graphite Black':
        case 'Grafit':
            return '#000';

        case 'Diamantschwarz':
            return '#000';

        case 'Ros&#233;gold':
            return 'rgb(208,168,160)';

        case 'Gold':
        case 'Gold-Sand':
            return 'rgb(212,187,163)';

        case 'Midnight Black':
        case 'Black-Sky':
            return '#000';

        case 'Lilac Purple':
            return 'rgb(159,122,159)';

        case 'Kinda Blue':
            return 'rgb(169,182,199)';

        case 'Midnight Blue':
            return 'rgb(30,130,177)';

        case 'Mocha Brown':
            return 'rgb(120,86,71)';

        case 'Dunkelblau':
            return 'rgb(130,140,153)';

        case 'Koralle':
            return '#FF6E5A';

        case 'Aurora Blue':
            return 'rgb(60,89,145);';

        case 'Not Pink':
            return '#ffb6c1;';

    }

    const mainColors = {
        "black" : "#000",
        "schwarz" : "#000",
        "blue" : '#48AEE6',
        "blau" : '#48AEE6',
        "red" : '#F24333',
        "rot" : '#F24333',
        "yellow" : '#F9D045',
        "gelb" : '#F9D045',
        "silver" : '#CCC',
        "silber" : '#CCC',
        "purple" : "rgb(159,122,159)",
        "lila" : "rgb(159,122,159)",
        "green" : "#007722",
        "grün" : "#007722"
    };

    if("string" === typeof color)  {
        for(let currentColor in mainColors) {
            if(-1 < color.toLowerCase().indexOf(currentColor)) {
               return mainColors[currentColor];
            }
        }
    }


    return '#F3F3F3';
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/get-hexcode-by-color.ts